import axios from 'axios'
import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn" //接口API
const url = {
    getStuTexts: root + "/Exam/getStuTexts", //检测->获取班别对应教材信息
    getInfo: root + "/Exam/getInfo", //检测->获取教材对应单元、组合单元、能力列表信息
    getUnitBranch: root + "/Exam/getUnitBranch", //检测->获取单元检测编号等信息息
    getGroupBranch: root + "/Exam/getGroupBranch", //检测->获取组合单元检测编号等信息
    getSubjects: root + "/Exam/getSubjects", //检测->通过检测编号获取题目信息
    getQuestion: root + "/Exam/getQuestion", //检测->根据问题ID获取问题信息
    getScore: root + "/Exam/getScore", //题目答案提交
    getSmallWrongScore: root + "/Exam/getSmallWrongScore", //错题题目 - 答案提交

    getWrongNum: root + "/Exam/getWrongNum", //检测->获取学生的错题数量
    getWrongQuestionBranch: root + "/Exam/getWrongQuestionBranch", //检测->获取错题检测编号等信息
    getExamHistory: root + "/Exam/getExamHistory", //获取学生检测 记录
    getAbilityAnalysis: root + "/Exam/getAbilityAnalysis", //检测->获取试卷能力分析
    getHistoryAnswers: root + "/Exam/getHistoryAnswers", //检测->获取检测答案
    getTestpaperQuestion: root + "/Exam/getTestpaperQuestion", //检测->获取真题试卷检测编号
    getRemoveWrongQuestion: root + "/Exam/getRemoveWrongQuestion", //检测->消除错题
    SubmitTask: `${root}/Stutask/SubmitTask`, // 任务中心->提交完成学生任务
}
const evaluationStore = {
    // 检测->获取班别对应教材信息
    getStuTexts(params) {
        return axios.get(url.getStuTexts, { params })
    },
    // 检测->获取教材对应单元、组合单元、能力列表信息
    getInfo(params) {
        return axios.get(url.getInfo, { params })
    },
    //检测->获取单元检测编号等信息息
    getUnitBranch(params) {
        return axios.post(url.getUnitBranch, qs.stringify(params))
    },
    //检测->获取组合单元检测编号等信息
    getGroupBranch(params) {
        return axios.post(url.getGroupBranch, qs.stringify(params))
    },
    // 检测->通过检测编号获取题目信息
    getSubjects(params) {
        return axios.get(url.getSubjects, { params })
    },
    // 检测->根据问题ID获取问题信息
    getQuestion(params) {
        return axios.get(url.getQuestion, { params })
    },
    //题目答案提交
    getScore(params) {
        return axios.post(url.getScore, qs.stringify(params))
    },
    //错题题目答案 - 提交
    getSmallWrongScore(params) {
        return axios.post(url.getSmallWrongScore, qs.stringify(params))
    },
    //检测->获取真题试卷检测编号 - 提交
    getTestpaperQuestion(params) {
        return axios.post(url.getTestpaperQuestion, qs.stringify(params))
    },
    //检测->获取学生的错题数量
    getWrongNum(params) {
        return axios.get(url.getWrongNum, { params })
    },
    //检测->获取错题检测编号等信息
    getWrongQuestionBranch(params) {
        return axios.post(url.getWrongQuestionBranch, qs.stringify(params))
    },
    //检测->获取试卷能力分析
    getAbilityAnalysis(params) {
        return axios.get(url.getAbilityAnalysis, { params })
    },
    //获取学生检测 记录
    getExamHistory(params) {
        return axios.get(url.getExamHistory, { params })
    },
    //检测->获取检测答案
    getHistoryAnswers(params) {
        return axios.get(url.getHistoryAnswers, { params })
    },
    //检测->消除错题
    getRemoveWrongQuestion(params) {
        return axios.get(url.getRemoveWrongQuestion, { params })
    },
    SubmitTask(params) {
    return axios.post(url.SubmitTask, qs.stringify(params))
    },
}

export default evaluationStore;